import fp from 'lodash/fp';
import { connect } from 'react-redux';
import ReportTemplateFormModal from '../../components/ReportTemplateFormModal';
import {
  fetchReportTemplates,
  createReportTemplate,
  updateReportTemplate
} from '../../redux/sagas/report-template/routines';
import {
  getIsSaving,
  getSavingError,
  getReportTemplatesByFileType
} from '../../redux/selectors/report-template';

function mapStateToProps(state, { fileType }) {
  return {
    ...state,
    templates: getReportTemplatesByFileType(state, fileType),
    isSaving: getIsSaving(state),
    error: getSavingError(state)
  };
}

function mapDispatchToProps(dispatch, { fileType }) {
  return {
    onInit: templates => {
      if (fp.isEmpty(templates)) {
        dispatch(fetchReportTemplates({ qs: { fileType } }));
      }
    },
    onSubmit: ({ id = null, ...template }) => {
      const file = fp.omit('dateRange', template.file);
      const body = fp.set('file', file, template);
      if (id) {
        dispatch(updateReportTemplate({ id, body }));
      } else {
        dispatch(createReportTemplate(body));
      }
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReportTemplateFormModal);
